module.exports = __webpack_public_path__ + "media/application/images/2023/01_still-1450x816-54d20ecf10d6cda783623d21a22e0f5f.png";